import { useState, useEffect } from 'react'
import OddsDisplay from './OddsDisplay'
import { getTeamLogoUrl, getTeamLogoFallbackUrl } from '../../lib/teamLogos'

const stateStyles = {
  default: 'bg-bg-primary/20 backdrop-blur-sm hover:bg-bg-card-hover/60 border-border hover:border-border-hover',
  selected: 'bg-accent/20 backdrop-blur-sm border-accent',
  locked: 'bg-bg-primary/20 backdrop-blur-sm border-border opacity-60 cursor-not-allowed',
  'locked-picked': 'bg-bg-primary/20 backdrop-blur-sm border-accent/50 cursor-not-allowed',
  correct: 'bg-bg-primary/20 backdrop-blur-sm border-correct',
  incorrect: 'bg-bg-primary/20 backdrop-blur-sm border-incorrect',
  postponed: 'bg-bg-primary/20 backdrop-blur-sm border-yellow-500',
  push: 'bg-bg-primary/20 backdrop-blur-sm border-yellow-500',
}

function PickLogo({ team, sportKey }) {
  const [src, setSrc] = useState(() => getTeamLogoUrl(team, sportKey))
  const [hidden, setHidden] = useState(false)
  useEffect(() => { setSrc(getTeamLogoUrl(team, sportKey)); setHidden(false) }, [team, sportKey])
  if (!src || hidden) return null
  return <img src={src} alt="" className="w-10 h-10 object-contain mx-auto my-1.5" onError={() => {
    const fallback = getTeamLogoFallbackUrl(team, sportKey)
    if (fallback && fallback !== src) setSrc(fallback)
    else setHidden(true)
  }} />
}

export default function PickButton({ team, odds, score, isLive, state = 'default', onClick, disabled, sportKey, rank, multiplier = 1 }) {
  const style = stateStyles[state] || stateStyles.default
  const hasResult = score != null
  const hasLogo = !!getTeamLogoUrl(team, sportKey)

  // When showing scores (live/final), use dark background for all states
  const bgOverride = hasResult && state === 'default' ? 'bg-bg-primary/20 backdrop-blur-sm border-border' : ''

  return (
    <button
      onClick={onClick}
      disabled={disabled || state === 'locked' || state === 'locked-picked' || state === 'correct' || state === 'incorrect' || state === 'postponed' || state === 'push'}
      className={`w-full min-w-0 p-4 rounded-xl border transition-all ${bgOverride || style} ${disabled && !hasResult ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <div className={`font-semibold text-xs sm:text-sm truncate ${hasLogo ? 'mb-0' : 'mb-1'} ${
        state === 'correct' ? 'text-correct'
        : state === 'incorrect' ? 'text-incorrect'
        : state === 'postponed' || state === 'push' ? 'text-yellow-500'
        : hasResult ? 'text-white'
        : 'text-text-primary'
      }`}>
        {/* AP Top 25 badge — NCAAF only, and only for ranked teams. Accent
            colored so it reads as a rank rather than part of the name. */}
        {rank ? <span className="text-accent mr-1">#{rank}</span> : null}
        {team}
      </div>
      <PickLogo team={team} sportKey={sportKey} />
      {score != null ? (
        <div className={`${hasLogo ? 'text-base' : 'text-lg'} font-display ${
          isLive && (state === 'locked-picked') ? 'text-accent'
          : state === 'correct' ? 'text-correct'
          : state === 'incorrect' ? 'text-incorrect'
          : state === 'postponed' || state === 'push' ? 'text-yellow-500'
          : 'text-white'
        }`}>{score}</div>
      ) : (
        <OddsDisplay odds={odds} isSelected={state === 'selected'} small={hasLogo} multiplier={multiplier} />
      )}
    </button>
  )
}
